import { RuleId, RuleLevel } from '../../../types-v2';
import { computeSiteDomOrderStatus } from './compute-site-dom-order-status';
export const domOrderRule = {
  checker: (context, tools) => {
    const status = computeSiteDomOrderStatus(tools, context);
    return {
      status
    };
  },
  level: RuleLevel.Site,
  ruleId: RuleId.DOM_ORDER
};
//# sourceMappingURL=dom-order.js.map